import { type ReactNode } from 'react';
import { Activity, Ban, FileText, Globe, LayoutDashboard, Mail, Webhook } from 'lucide-react';
import { AppShell, type NavItem } from '@beamx/shared';
import { useApiKey } from '../lib/auth/ApiKeyContext.js';

const NAV: NavItem[] = [
  { label: 'Dashboard', to: '/', icon: LayoutDashboard, end: true },
  { label: 'Compose', to: '/compose', icon: Mail },
  { label: 'Sender domains', to: '/sender-domains', icon: Globe },
  { label: 'Templates', to: '/templates', icon: FileText },
  { label: 'Activity', to: '/activity', icon: Activity },
  { label: 'Webhooks', to: '/webhooks', icon: Webhook },
  { label: 'Suppression', to: '/suppression', icon: Ban },
];

/** App chrome for the tenant console. "Sign out" disconnects the stored API key. */
export function CustomerShell({ children }: { children: ReactNode }) {
  const { apiKey, set } = useApiKey();
  const tail = apiKey ? `…${apiKey.slice(-4)}` : '';
  return (
    <AppShell
      brandName="BeamX"
      brandSubtitle="Console"
      navItems={NAV}
      user={{ name: 'Connected', email: tail, badge: 'API key' }}
      onSignOut={() => set(null)}
    >
      {children}
    </AppShell>
  );
}
